import React from 'react';
import * as PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import WorkArea from '../../containers/Engineering/WorkArea';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

import './WorkAreaPanel.sass';

const PanelTitle = ({ position, setPosition }) => {
  let leftButton, rightButton;

  if (position === 'left') {
    leftButton = (
      <Button
        disabled
        size="sm"
        title="Dock Left"
        variant="default"
        className="dock-position-button"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>
    );
    rightButton = (
      <Button
        size="sm"
        className="dock-position-button"
        onClick={() => setPosition('right')}
        title="Dock Right"
        variant="default"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </Button>
    );
  } else {
    leftButton = (
      <Button
        size="sm"
        className="dock-position-button"
        onClick={() => setPosition('left')}
        title="Dock Left"
        variant="default"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>
    );
    rightButton = (
      <Button
        disabled
        size="sm"
        title="Dock Right"
        variant="default"
        className="dock-position-button"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </Button>
    );
  }

  return (
    <div className="docking-station box box-row box-min">
      {leftButton}
      <h2 className="title">Work Areas</h2>
      {rightButton}
    </div>
  );
};

PanelTitle.propTypes = {
  position: PropTypes.oneOf(['left', 'right']),
  setPosition: PropTypes.func,
};

PanelTitle.defaultProps = {
  position: 'left',
};

const WorkAreaPanel = ({
  detachable,
  position,
  workAreas,
  setDockPosition,
  anyLoading,
  alldata,
}) => {
  let children = [];

  for (let key in workAreas) {
    if (workAreas.hasOwnProperty(key) && workAreas[key].open) {
      children.push(
        <WorkArea
          key={key}
          node={key}
          detachable={detachable}
          anyLoading={anyLoading}
          alldata={alldata}
          {...workAreas[key]}
        />
      );
    }
  }

  let classes = 'box box-col workareas';
  if (position === 'left') {
    classes += ' dock-left';
  } else {
    classes += ' dock-right';
  }

  return children.length === 0 ? null : (
    <div className={classes}>
      <PanelTitle position={position} setPosition={setDockPosition} />
      <div className="box">{children}</div>
    </div>
  );
};

WorkAreaPanel.propTypes = {
  detachable: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right']),
  workAreas: PropTypes.object,
  setDockPosition: PropTypes.func,
  anyLoading: PropTypes.bool,
};

WorkAreaPanel.defaultProps = {
  config: {},
  detachable: false,
  position: 'right',
  anyLoading: false,
};

export default WorkAreaPanel;
